export const ENTITY_ATTRIBUTE_TYPE = {
  PROFILE_BACKGROUND_IMAGE: "profileBackgroundImage",
  BANNER_IMAGE: "bannerImage",
  BANNER_IMAGE_CROP_DATA: "bannerImageCropData",
  IMAGE: "image",
  IMAGE_CROP_DATA: "imageCropData",
};
